import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';
import Image from 'next/image';
import Link from 'next/link';

export const FabricDialog = () => {
  return (
    <Dialog>
      <div>
        <span className='text-sm leading-5'>
          {' '}
          This dress is available in different fabric options, view the difference{' '}
        </span>
        <DialogTrigger asChild>
          <span className='cursor-pointer text-sm underline'>here</span>
        </DialogTrigger>
      </div>

      <DialogContent className='h-[calc(100vh-40px)] w-[calc(100vw-40px)] p-0 lg_h-[590px] lg_w-[1200px] lg_max-w-[1200px] '>
        <div className='h-full overflow-y-auto px-[10px] py-[32px] lg_p-[78px]'>
          <div className='flex flex-col gap-9'>
            <div className='flex flex-col justify-between gap-[18px] lg_flex-row lg_gap-9'>
              <Image
                src={`${process.env.NEXT_PUBLIC_BASE_PATH}/product-full-detail/fabric.webp`}
                alt='Crystal Satin'
                width={400}
                height={400}
                className='w-full lg_w-[400px]'
              />

              <div className='flex-1'>
                <span className='inline-block w-full border-b-1 border-solid border-[#E7DED5] text-center font-Shango text-[24px] leading-[52px] text-primary lg_w-fit lg_text-left lg_text-[32px]'>
                  Fabric: Crystal Satin
                </span>
                <h4 className='mt-[30px] text-center font-Shango text-[22px] text-primary lg_text-left'>Features</h4>
                <div className='mt-[22px] flex gap-[6px] lg_gap-4'>
                  {[
                    {
                      title: 'Strong Luster',
                      image: `${process.env.NEXT_PUBLIC_BASE_PATH}/product-full-detail/fabric-item-1.webp`,
                      width: 69,
                      height: 79,
                    },
                    {
                      title: 'Durable',
                      image: `${process.env.NEXT_PUBLIC_BASE_PATH}/product-full-detail/fabric-item-2.webp`,
                      width: 116,
                      height: 114,
                    },
                    {
                      title: 'Beautiful Drape',
                      image: `${process.env.NEXT_PUBLIC_BASE_PATH}/product-full-detail/fabric-item-3.webp`,
                      width: 81,
                      height: 70,
                    },
                  ].map((i, index) => (
                    <div
                      key={index}
                      className='flex h-[131px] w-1/3 flex-col items-center justify-center bg-[#f8f3ef] lg_h-[212px]'
                    >
                      <div className='flex h-[45px] w-[45px] items-center justify-center lg_h-[114px] lg_w-[114px]'>
                        <Image
                          src={i.image}
                          alt={i.title}
                          width={i.width}
                          height={i.height}
                          className='h-full w-full lg_h-fit lg_w-fit'
                        />
                      </div>
                      <h5 className='mt-[18px] text-center font-Shango text-[16px] text-primary lg_mt-0 lg_text-[22px]'>
                        {i.title}
                      </h5>
                    </div>
                  ))}
                </div>

                <div className='mt-[45px] flex justify-center gap-4'>
                  <Button
                    variant='secondary'
                    asChild
                    className='h-[40px] w-1/2 lg_w-[165px]'
                  >
                    <Link
                      href='/fabrics/crystal-satin-vs-satin-charmeuse-comparison'
                      className='h-full w-full'
                    >
                      LEARN MORE
                    </Link>
                  </Button>
                  <Button
                    asChild
                    className='h-[40px] w-1/2 lg_w-[165px]'
                  >
                    <Link
                      href='/aw-crystal-satin-swatches-for-bridal-dresses-sk24110cscp.html'
                      className='h-full w-full'
                    >
                      Shop Swatches
                    </Link>
                  </Button>
                </div>
              </div>
            </div>

            <div className='flex flex-col-reverse justify-between gap-9 lg_flex-row'>
              <div className='flex-1'>
                <span className='inline-block w-full border-b-1 border-solid border-[#E7DED5] text-center font-Shango text-[24px] leading-[52px] text-primary lg_w-fit lg_text-left lg_text-[32px]'>
                  Fabric: Satin Charmeuse
                </span>
                <h4 className='mt-[30px] text-center font-Shango text-[22px] text-primary lg_text-left'>Features</h4>
                <div className='mt-[22px] flex gap-[6px] lg_gap-4'>
                  {[
                    {
                      title: 'Relatively Subtle Sheen',
                      image: `${process.env.NEXT_PUBLIC_BASE_PATH}/product-full-detail/fabric-item-4.webp`,
                      width: 69,
                      height: 79,
                    },
                    {
                      title: 'Silky',
                      image: `${process.env.NEXT_PUBLIC_BASE_PATH}/product-full-detail/fabric-item-5.webp`,
                      width: 116,
                      height: 114,
                    },
                    {
                      title: 'Soft',
                      image: `${process.env.NEXT_PUBLIC_BASE_PATH}/product-full-detail/fabric-item-6.webp`,
                      width: 81,
                      height: 70,
                    },
                  ].map((i, index) => (
                    <div
                      key={index}
                      className='flex h-[131px] w-1/3 flex-col items-center justify-center bg-[#f8f3ef] lg_h-[212px]'
                    >
                      <div className='flex h-[45px] w-[45px] items-center justify-center lg_h-[114px] lg_w-[114px]'>
                        <Image
                          src={i.image}
                          alt={i.title}
                          width={i.width}
                          height={i.height}
                          className='h-full w-full lg_h-fit lg_w-fit'
                        />
                      </div>
                      <h5 className='mt-[18px] text-center font-Shango text-[16px] text-primary lg_mt-0 lg_text-[22px]'>
                        {i.title}
                      </h5>
                    </div>
                  ))}
                </div>

                <div className='mt-[45px] flex justify-center gap-4'>
                  <Button
                    variant='secondary'
                    asChild
                    className='h-[40px] w-1/2 lg_w-[165px]'
                  >
                    <Link
                      href='/fabrics/crystal-satin-vs-satin-charmeuse-comparison'
                      className='h-full w-full'
                    >
                      LEARN MORE
                    </Link>
                  </Button>
                  <Button
                    asChild
                    className='h-[40px] w-1/2 lg_w-[165px]'
                  >
                    <Link
                      href='/aw-satin-charmeuse-swatches-for-bridal-dresses-awsk210u2stcp.html'
                      className='h-full w-full'
                    >
                      Shop Swatches
                    </Link>
                  </Button>
                </div>
              </div>

              <Image
                src={`${process.env.NEXT_PUBLIC_BASE_PATH}/product-full-detail/fabric-2.webp`}
                alt='Crystal Satin'
                width={400}
                height={400}
              />
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
